import styled from 'styled-components';

const InputElement = styled.input`
    border: 0!important;
    border-radius: 4px!important;
    padding: 12px 16px!important;
    margin: 8px 0!important;
    outline: none;
    background-color: #f5f5f5;
    ::placeholder {
        color: #999;
    }
`;

const Checkbox = ({...props}) => {
    return (
        <InputElement type='checkbox' {...props}/>
    );
}

export default Checkbox;
